module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-hb.b63285d1.png";